import { COLUMN_BUILDING, COLUMN_DOOR, COLUMN_ENTRY_READER, COLUMN_EXIT_READER, COLUMN_FLOOR, COLUMN_NAME, COLUMN_SITE, COLUMN_ZONE } from "../../constants/column-types";
import { FILTER_DOORS, FILTER_SITES, FILTER_ZONES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const AreaReportColumn : TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "area.areaName",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Location",
        accessor: "location",
        isNumeric: false,
        id: 1,
        sortByName: "locName",
        searchOnName: "location.id",
        lookupName: "locName",
        sortDirection: "asc",
        active: true,
        translationKey: "location",
        columnId: COLUMN_DOOR,
        filterId: FILTER_DOORS,
        settingDataName: 'location'
    },
    {
        heading: "Entry Reader",
        accessor: "entryReader",
        isNumeric: false,
        id: 2,
        active: true,
        translationKey: "entryReader",
        columnId: COLUMN_ENTRY_READER,
    },
    {
        heading: "Exit Reader",
        accessor: "exitReader",
        isNumeric: false,
        id: 3,
        active: true,
        translationKey: "exitReader",
        columnId: COLUMN_EXIT_READER,
    },
    {
        heading: "Zone",
        accessor: "zone",
        isNumeric: false,
        id: 4,
        sortByName: "location.zoneByZoneId.zoneName",
        lookupName: "location.zoneByZoneId.zoneName",
        searchOnName: "location.zoneByZoneId.id",
        sortDirection: "asc",
        active: true,
        translationKey: "zone",
        columnId: COLUMN_ZONE,
        filterId: FILTER_ZONES,
        settingDataName: 'zone'
    },
    {
        heading: "Building",
        accessor: "building",
        isNumeric: false,
        id: 5,
        // sortByName: "location.terminals.building.buildingName", // Sorting on to-many relationships is not supported.
        // sortDirection: "asc",
        active: true,
        translationKey: "building",
        columnId: COLUMN_BUILDING,
    },
    {
        heading: "Floor",
        accessor: "floor",
        isNumeric: false,
        id: 6,
        // sortByName: "location.terminals.floor.floorName", // Sorting on to-many relationships is not supported.
        // sortDirection: "asc",
        active: true,
        translationKey: "floor",
        columnId: COLUMN_FLOOR,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 7,
        // sortByName: "location.terminals.site.siteName", // Sorting on to-many relationships is not supported.
        // sortDirection: "asc",
        active: false,
        translationKey: "site",
        columnId: COLUMN_SITE,
    },
];

export default AreaReportColumn;
